export default [
  {
    path: 'stat/renewal/customer',
    component: () => import('@/views/stat/RenewalCustomer.vue'),
    meta: { title: '待续保分析' }
  },
  {
    path: 'statistics',
    component: () => import('@/views/stat/PersonEffectiveness.vue'),
    meta: { title: '人员效能' }
  }
]
